import { cn } from "../lib/utils";

/** "← Home": the way back from a page opened off another, above its content. */
export default function BackLink({ to, onClick, className }: { to: string; onClick: () => void; className?: string }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn("self-start text-[13px] text-melt-text3 hover:text-melt-text1", className)}
    >
      ← {to}
    </button>
  );
}
